import React, {useEffect, useState} from "react";
import {getFetcherAnalysis} from "../../utils/fetcher_gameAnlysis";
import {GET_POINT_GRAPH_DATA_API} from "../../constants/api_constants";
import {ModalHandler} from "../Modal/Generic/ModalHandler";
import ChartLine from "./ChartLine";
import {getImage} from "../../constants/constants";


const PointGraph = ({dataId, analysisType}) => {
  const [pointData, setPointData] = useState([]);
  const [homeData, setHomeData] = useState([]);
  const [awayData, setAwayData] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [isNullData, setIsNullData] = useState(false);

  useEffect(() => {
    getGraphData();
  }, [dataId]);

  const getGraphData = () => {
    getFetcherAnalysis().get(GET_POINT_GRAPH_DATA_API + `?dataId=${dataId}&analysisType=${analysisType}`)
        .then(res => {
          const {responseIsSuccess, data, responseResultDescription} = res.data;
          if (responseIsSuccess) {
            if (data[0].length === 0) {
              setIsNullData(true);
              setIsLoading(false);
              return;
            }
            setPointData(data[0]);
            setHomeData(data[0].home);
            setAwayData(data[0].away);

            setIsLoading(false);
          } else {
            console.log("데이터 불러오기 실패 -> ", responseResultDescription);
            setIsNullData(true);
            setIsLoading(false);
          }
        }).catch(err => console.log(err));
  }

  if (isLoading) {
    return (
        <div className="w-full h-screen flex flex-col justify-center items-center fixed top-0 left-0 overflow-hidden">
          <img src={getImage('loadingImage')} alt="loadingImage" className="h-32 w-auto"/>
          <span className="font-bold text-sky-700"> 데이터 불러오는중... </span>
        </div>
    )
  }
  if (isNullData) {
    return (
        <div className="w-full h-screen flex flex-col justify-center items-center fixed top-0 left-0 overflow-hidden">
          <img src={getImage('notFound')} alt="notFoundImage" className="h-40 w-auto"/>
          <span className="font-bold text-indigo-800 pt-3 text-lg pointer-events-auto"> 데이터가 없습니다. </span>
        </div>
    )
  }

  return (
      <div className="w-full px-1 min-h-[calc(100vh-8rem)]">
        <ChartLine
            homeData={homeData}
            awayData={awayData}
            homeName={pointData.home_name}
            awayName={pointData.away_name}
        />
      </div>
  )
}
export default PointGraph;

